module.exports = __webpack_public_path__ + "static/img/compass.9513e9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compass.png
// module id = Pcw4
// module chunks = 0